export default __webpack_public_path__ + "static/media/graphing.e5407663.png";